export const postToApp = (type, data = {}) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ type, ...data }));
  }
};

export const requestFromApp = (type) => {
  if (!window.ReactNativeWebView) return Promise.resolve({});
  return new Promise((resolve) => {
    const handleMessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.type === type) {
          window.removeEventListener('message', handleMessage);
          document.removeEventListener('message', handleMessage);
          resolve(data);
        }
      } catch (e) {
        // Non-JSON message, ignore.
      }
    };
    window.addEventListener('message', handleMessage);
    document.addEventListener('message', handleMessage);
    postToApp(type);
  });
};
